import { action, createRequestTypes } from '../../base';

export const rfqActionTypes = {
  GET_RFQ: createRequestTypes('GET_RFQ'),
  GET_RFQ_BY_ID: createRequestTypes('GET_RFQ_BY_ID'),
  CREATE_RFQ: createRequestTypes('CREATE_RFQ'),
  UPDATE_RFQ: createRequestTypes('UPDATE_RFQ'),
  UPDATE_RFQ_PARTICIPANT: createRequestTypes('UPDATE_RFQ_PARTICIPANT'),
  UPDATE_RFQ_CONFIG: createRequestTypes('UPDATE_RFQ_CONFIG'),
  SEND_RFQ_NOTIFICATION: createRequestTypes('SEND_RFQ_NOTIFICATION'),
  DELETE_RFQ: createRequestTypes('DELETE_RFQ'),
  UPDATE_STATUS_RFQ: createRequestTypes('UPDATE_STATUS_RFQ'),
  GET_PUBLIC_RFQ: createRequestTypes('GET_PUBLIC_RFQ'),
  NEGOTIATION: createRequestTypes('NEGOTIATION'),
  GET_ACCEPTED_OFFERS: createRequestTypes('GET_ACCEPTED_OFFERS'),
  GET_RFQ_PARTICIPANT_NEGOTIATIONS: createRequestTypes('GET_RFQ_PARTICIPANT_NEGOTIATIONS'),
};

/**
 * @param payload
 * @param callback
 */
class RfqActions {
  /**
   * @param {*} orgId
   * @param {*} status
   * @param {*} tenantId
   * @param {*} page
   * @param {*} limit
   * @param searchKeyword
   * @return
   */
  getRfq = (orgId, tenantId, page, limit, status, onDate, fromDate, toDate, searchKeyword, is_list) => action(rfqActionTypes.GET_RFQ.REQUEST, {
    orgId, tenantId, page, limit, status, onDate, fromDate, toDate, searchKeyword, is_list
  })

  /**
   *
   * @param getRfqLoading
   * @return {{type: *}}
   */
  getRfqLoading = (getRfqLoading) => action(rfqActionTypes.GET_RFQ.LOADING, {
    getRfqLoading,
  })

  /**
   * @param purchaseOrders
   * @param orgPos
   * @return {{type: *}}
   */
  getRfqSuccess = (rfqs) => action(rfqActionTypes.GET_RFQ.SUCCESS, {
    rfqs,
  })

  /**
   * @param payload
   * @param callback
   * @return {{type: *}}
   */
  createRfq = (payload, callback) => action(rfqActionTypes.CREATE_RFQ.REQUEST, {
    payload,
    callback,
  })

  /**
   * @param createRfqLoading
   * @param addCustomRfqLoading
   * @return {{type: *}}
   */
  createRfqLoading = (createRfqLoading) => action(rfqActionTypes.CREATE_RFQ.LOADING, {
    createRfqLoading,
  })

  /**
   * @param {*} payload
   * @param {*} callback
   * @return
   */
  updateRfq = (payload, callback) => action(rfqActionTypes.UPDATE_RFQ.REQUEST, {
    payload,
    callback,
  })

  /**
   *
   * @param updateRfqLoading
   * @return {{type: *}}
   */
  updateRfqLoading = (updateRfqLoading) => action(rfqActionTypes.UPDATE_RFQ.LOADING, {
    updateRfqLoading,
  })

  /**
   * @param {*} payload
   * @param {*} callback
   * @return
   */
  updateRfqParticipant = (payload, callback) => action(rfqActionTypes.UPDATE_RFQ_PARTICIPANT.REQUEST, {
    payload,
    callback,
  })

  /**
   *
   * @param updateRfqParticipantLoading
   * @return {{type: *}}
   */
  updateRfqParticipantLoading = (updateRfqParticipantLoading) => action(rfqActionTypes.UPDATE_RFQ_PARTICIPANT.LOADING, {
    updateRfqParticipantLoading,
  })

  /**
 * @param {*} payload
 * @param {*} callback
 * @return
 */
  updateRfqConfig = (payload, callback) => action(rfqActionTypes.UPDATE_RFQ_CONFIG.REQUEST, {
    payload,
    callback,
  })

  /**
   *
   * @param updateRfqConfigLoading
   * @return {{type: *}}
   */
  updateRfqConfigLoading = (updateRfqConfigLoading) => action(rfqActionTypes.UPDATE_RFQ_CONFIG.LOADING, {
    updateRfqConfigLoading,
  })

  /**
   * @param orgId
   * @param tenantId
   * @param callback
   * @return {{type: *}}
   */
  getRfqById = (orgId, tenantId, rfqId, callback, dontShowLoading) => action(rfqActionTypes.GET_RFQ_BY_ID.REQUEST, {
    orgId, tenantId, rfqId, callback, dontShowLoading
  })

  /**
   * @param getRfqByIdLoading
   * @return {{type: *}}
   */
  getRfqByIdLoading = (getRfqByIdLoading) => action(rfqActionTypes.GET_RFQ_BY_ID.LOADING, {
    getRfqByIdLoading,
  })

  /**
  * @param selectedRfq
  * @param selectedPo
  * @return {{type: *}}
  */
  getRfqByIdSuccess = (selectedRfq) => action(rfqActionTypes.GET_RFQ_BY_ID.SUCCESS, {
    selectedRfq,
  })

  /**
 * @param payload
 * @param callback
 * @return {{type: *}}
 */
  sendRfqNotification = (payload, callback) => action(rfqActionTypes.SEND_RFQ_NOTIFICATION.REQUEST, {
    payload,
    callback,
  })

  /**
   * @param sendRfqNotificationLoading
   * @param addCustomRfqLoading
   * @return {{type: *}}
   */
  sendRfqNotificationLoading = (sendRfqNotificationLoading) => action(rfqActionTypes.SEND_RFQ_NOTIFICATION.LOADING, {
    sendRfqNotificationLoading,
  })

  /**
   *
   * @param payload
   * @param callback
   * @return {{type: *}}
   */
  deleteRfq = (payload, callback) => action(rfqActionTypes.DELETE_RFQ.REQUEST, {
    payload, callback,
  })

  /**
   *
   * @param deleteRfqLoading
   * @return {{type: *}}
   */
  deleteRfqLoading = (deleteRfqLoading) => action(rfqActionTypes.DELETE_RFQ.LOADING, {
    deleteRfqLoading,
  })

  /**
  * @param payload
  * @param callback
  * @return {{type: *}}
  */
  updateRfqStatus = (payload, callback) => action(rfqActionTypes.UPDATE_STATUS_RFQ.REQUEST, {
    payload, callback,
  })

  /**
   * @param updateRfqStatusLoading
   * @param deleteRfqLoading
   * @return {{type: *}}
   */
  updateRfqStatusLoading = (updateRfqStatusLoading) => action(rfqActionTypes.UPDATE_STATUS_RFQ.LOADING, {
    updateRfqStatusLoading,
  })

  /**
   *
   * @param accessToken
   * @param callback
   * @returns {{type: *}}
   */
  getPublicRfq = (accessToken, callback) => action(rfqActionTypes.GET_PUBLIC_RFQ.REQUEST, {
    accessToken, callback,
  })

  /**
   *
   * @param getPublicRfqLoading
   * @returns {{type: *}}
   */
  getPublicRfqLoading = (getPublicRfqLoading) => action(rfqActionTypes.GET_PUBLIC_RFQ.LOADING, {
    getPublicRfqLoading,
  })

  /**
   *
   * @param publicRfqError
   * @returns {{type: *}}
   */
  getPublicRfqError = (publicRfqError) => action(rfqActionTypes.GET_PUBLIC_RFQ.ERROR, {
    publicRfqError,
  })

  /**
   *
   * @param publicRfq
   * @returns {{type: *}}
   */
  getPublicRfqSuccess = (publicRfq) => action(rfqActionTypes.GET_PUBLIC_RFQ.SUCCESS, {
    publicRfq,
  })

  /**
   *
   * @param actionType
   * @param payload
   * @param callback
   * @returns {{type: *}}
   */
  negotiationAction = (actionType, payload, callback) => action(rfqActionTypes.NEGOTIATION.REQUEST, {
    actionType, payload, callback,
  })

  /**
   *
   * @param actionType
   * @param loading
   * @returns {{type: *}}
   */
  negotiationActionLoading = (actionType, loading) => action(rfqActionTypes.NEGOTIATION.LOADING, {
    actionType, loading,
  })

  /**
   *
   * @param payload
   * @param callback
   * @returns {{type: *}}
   */
  getAcceptedOffers = (payload, callback) => action(rfqActionTypes.GET_ACCEPTED_OFFERS.REQUEST, {
    payload, callback,
  })

  /**
   *
   * @param getAcceptedOffersLoading
   * @returns {{type: *}}
   */
  getAcceptedOffersLoading = (getAcceptedOffersLoading) => action(rfqActionTypes.GET_ACCEPTED_OFFERS.LOADING, {
    getAcceptedOffersLoading,
  })

  /**
   *
   * @param acceptedOffers
   * @returns {{type: *}}
   */
  getAcceptedOffersSuccess = (acceptedOffers) => action(rfqActionTypes.GET_ACCEPTED_OFFERS.SUCCESS, {
    acceptedOffers,
  })

  /**
   * @param orgId
   * @param tenantId
   * @param callback
   * @return {{type: *}}
   */
  getRfqParticipantNegotiations = (rfqParticipantId, callback) => action(rfqActionTypes.GET_RFQ_PARTICIPANT_NEGOTIATIONS.REQUEST, {
    rfqParticipantId, callback,
  })

  /**
   * @param getRfqParticipantNegotiationsLoading
   * @return {{type: *}}
   */
  getRfqParticipantNegotiationsLoading = (getRfqParticipantNegotiationsLoading) => action(rfqActionTypes.GET_RFQ_PARTICIPANT_NEGOTIATIONS.LOADING, {
    getRfqParticipantNegotiationsLoading,
  })

  /**
  * @param participantNegotiations
  * @return {{type: *}}
  */
  getRfqParticipantNegotiationsSuccess = (participantNegotiations) => action(rfqActionTypes.GET_RFQ_PARTICIPANT_NEGOTIATIONS.SUCCESS, {
    participantNegotiations,
  })
}

export default new RfqActions();
